import type { IconData } from '@stacksjs/iconify-core'

export const resetClock: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M10.39 40.23c1.06.887 2.621.551 3.376-.606l.547-.838c.753-1.156.41-2.69-.604-3.626a14.96 14.96 0 0 1-4.837-11.032c0-8.284 6.716-15 15-15s15 6.716 15 15c0 4.236-1.756 8.061-4.58 10.789a53 53 0 0 0-2.95-3.084c-.956-.912-2.357-.437-2.593.864c-.502 2.758-.726 5.917-.822 8.543a2.876 2.876 0 0 0 2.482 2.957c2.587.36 5.715.686 8.507.674c1.336-.005 2.056-1.328 1.315-2.44a52 52 0 0 0-2.095-2.891a20.94 20.94 0 0 0 6.736-15.412c0-11.598-9.402-21-21-21s-21 9.402-21 21c0 6.466 2.922 12.25 7.518 16.102\"/><path d=\"M24 15v9l-6 6\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default resetClock
